export const STEPS = [
  { id: "select", title: "1 / 4  Select", text: "Tap a friendly unit. Ice-blue is GVS (you)." },
  { id: "move", title: "2 / 4  Move", text: "Hit Move, tap a highlighted hex, then Commit or Enter." },
  { id: "attack", title: "3 / 4  Attack", text: "Hit Attack. Hover an enemy to preview damage, then tap to fire." },
  { id: "end", title: "4 / 4  End turn", text: "End turn to claim ore and let the Brotherhood answer." },
];

const ORDER = STEPS.map((s) => s.id);

export function stepById(id) {
  return STEPS.find((s) => s.id === id) ?? null;
}

/** Pure coach cursor. Returns the next step id, or null when finished / skipped. */
export function advance(stepId, event) {
  if (!stepId || event === "skip") return null;
  if (!ORDER.includes(stepId)) return null;
  if (stepId === "select" && event === "select") return "move";
  if (stepId === "move" && (event === "moved" || event === "mode-move")) return event === "moved" ? "attack" : stepId;
  if (stepId === "attack" && (event === "attack-mode" || event === "attacked")) return "end";
  if (stepId === "end" && event === "ended") return null;
  return stepId;
}

const STORAGE_KEY = "iron-command-coach";

export function shouldShow(storage) {
  try {
    return (storage ?? globalThis.sessionStorage)?.getItem(STORAGE_KEY) !== "off";
  } catch {
    return true;
  }
}

export function dismiss(storage) {
  try {
    (storage ?? globalThis.sessionStorage)?.setItem(STORAGE_KEY, "off");
  } catch {
    /* private mode */
  }
}

export function reset(storage) {
  try {
    (storage ?? globalThis.sessionStorage)?.removeItem(STORAGE_KEY);
  } catch {
    /* private mode */
  }
}
